

























































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import CustomConfirm from "../../components/CustomConfirmModal.vue";
import { BModal } from 'bootstrap-vue';
import { PracticeCompareSheetListCondition, RowSpanInfo } from "../../modules/teacher/PracticeCompareSheetList"

export interface Data {
  condition: PracticeCompareSheetListCondition
  sheets: any[]
  totalCount: number
  sheetRowSpanInfos: RowSpanInfo[]
  errors: string[]
  isShow: boolean
  isAllCheckedApproval: boolean
  isAllCheckedFirstApproval: boolean
  isAllCheckedSecondApproval: boolean
  compare_no: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    const CompareNoEnum = Common.CompareNoEnum;

    const customConfirmModalRef = ref<InstanceType<typeof CustomConfirm>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new PracticeCompareSheetListCondition(),
      sheets: [],
      totalCount: 0,
      sheetRowSpanInfos: new Array<RowSpanInfo>(),
      errors: new Array<string>(),
      isShow: false,
      isAllCheckedApproval: false,
      isAllCheckedFirstApproval: false,
      isAllCheckedSecondApproval: false,
      compare_no: null,
    });

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/teacher/practice_compare_sheet_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        const sheets = response.data.sheets;

        const sheetRowSpanInfos = new Array<RowSpanInfo>();
        for(let i = 0; i < sheets.length; i++){
          const sheet = sheets[i];
          if(sheetRowSpanInfos.length == 0 || sheetRowSpanInfos[sheetRowSpanInfos.length - 1].sheet_group_key != sheet.sheet_group_key){
            sheetRowSpanInfos.push(new RowSpanInfo(sheet.id, sheet.sheet_group_key, 1));
          }else{
            sheetRowSpanInfos[sheetRowSpanInfos.length - 1].count++;
          }
        }
        state.sheetRowSpanInfos = sheetRowSpanInfos;

        state.totalCount = response.data.full_count;
        
        state.sheets = sheets;

        context.root.$store.commit("setPracticeCompareSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    }

    /******************************
     * クリアボタン押下
     ******************************/
    
    const clearCondition = () => {
      state.condition = new PracticeCompareSheetListCondition();
    };

    /******************************
     * 一覧テーブル rowspan設定
     * 同一sheet_group_keyの先頭レコードの場合
     * rowspanを設定する
     ******************************/
    
    const rowSpan = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? rowInfo[0].count : 1;
    };

    /******************************
     * 一覧テーブル tdの表示制御
     * rowspan未設定行を非表示にする
     ******************************/
    
    const tdStyle = (sheet: any) => {
      const rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? {} : {"display": "none"};
    };

    /******************************
     * 全体平均点計算
     ******************************/
    const calcAllAverage = (sheet: any) => {
      const sheets = state.sheets.filter((x: any) => x.sheet_group_key == sheet.sheet_group_key);
      const score = Common.sumArray(sheets.map((x: any) => Number(x.at_sum_score)));
      const attendCount = Common.sumArray(sheets.map((x: any) => x.at_attend_count));
      
      return Number(Math.round(score * 10 / attendCount)) / 10;
    };

    /******************************
     * 一覧テーブル trのスタイル
     ******************************/
    
    const trStyle = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_group_key == sheet.sheet_group_key);
      if(rowInfo.length > 0){
        var rowIdx = state.sheetRowSpanInfos.indexOf(rowInfo[0]);
        return rowIdx % 2 == 1 ? {"background-color": "#f2f2f2"} : {};
      }
    };

    /******************************
     * 実施日列の表示用に日付文字列をコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * 一覧のページ変更
     ******************************/
    
    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 採点設定アイコン押下
     ******************************/
    
    const saitenSettingClick = (sheet: any) => {

      context.root.$store.commit("setIsDigitalPaper", sheet.is_digital_paper);
      context.root.$store.commit("setIsRecogPositionEditEnable", sheet.is_recog_position_edit_enable);

      // 採点設定の進捗により遷移先を制御
      if(sheet.score_positions_completed){
        if(sheet.is_recog_position_edit_enable){
          context.root.$router.push(`/teacher_site/recog_position_edit/${sheet.sheet_group_key}`).catch(err => {});
        }else{
          context.root.$router.push(`/teacher_site/score_position_edit/${sheet.sheet_group_key}`).catch(err => {});
        }
      }else if(sheet.corretct_image_completed){
        context.root.$router.push(`/teacher_site/position_edit/${sheet.sheet_group_key}`).catch(err => {});
      }else if(sheet.part1_names_completed){
        context.root.$router.push(`/teacher_site/correct_image_upload/${sheet.sheet_group_key}`).catch(err => {});
      }else if(sheet.field_names_completed){
        context.root.$router.push(`/teacher_site/practice_part1_edit/${sheet.sheet_group_key}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/practice_field_edit/${sheet.sheet_group_key}`).catch(err => {});
      }
    };

    /******************************
     * 採点一覧へ遷移
     ******************************/

    const saitenListClick = (sheet: any, compare_no: number) => {
      context.root.$store.commit("setCompareNo", compare_no);
      context.root.$router.push(`/teacher_site/saiten_list/${sheet.id}`).catch(err => {});
    }
    
    /******************************
     * 画面リロード
     ******************************/

    const reload = () => {
      location.reload();
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      state.condition = context.root.$store.state.practiceCompareSheetListCondition as PracticeCompareSheetListCondition;
      await search();
      context.root.$store.commit("setIsFilterMisaiten", null);
      context.root.$store.commit("setIsHeaderDisp", true);
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.PracticeCompare);
      state.isShow = true;
    });

    /******************************
     * A採点承認チェックボックス全件選択
     ******************************/
    
     watch(() => state.isAllCheckedFirstApproval, (newVal, oldVal) => {
      state.sheets.filter((x: any) => x.at_first_progress_rate >= 100).forEach((x: any) => x.first_approval_flg = newVal);
    });

    /******************************
     * B採点承認チェックボックス全件選択
     ******************************/
    
     watch(() => state.isAllCheckedSecondApproval, (newVal, oldVal) => {
      state.sheets.filter((x: any) => x.at_second_progress_rate >= 100).forEach((x: any) => x.second_approval_flg = newVal);
    });

    /******************************
     * 最終採点承認チェックボックス全件選択
     ******************************/
    
    watch(() => state.isAllCheckedApproval, (newVal, oldVal) => {
      state.sheets.filter((x: any) => x.saiten_flg).forEach((x: any) => x.approval_flg = newVal);
    });

    /************************************************************
     * 承認ボタン押下
     * A・B採点の承認リセットに連動して最終採点の承認もリセットされる場合は
     * モーダルに注意メッセージを表示
     * 最終採点・コンペア以外の採点の場合はそのまま更新
     ************************************************************/
     const approvalButtonClick = async (compare_no: number) => {
      
      state.compare_no = compare_no;

      const paramSheets: any[] = [];
      if(state.compare_no == CompareNoEnum.CompareFirst){
        state.sheets.filter((x: any) => x.at_first_progress_rate >= 100 && x.first_approval_flg != x.first_approval_flg_cache).forEach((x: any) => paramSheets.push({id: x.id, approval_flg: x.first_approval_flg}));
      }else if(state.compare_no == CompareNoEnum.CompareSecond){
        state.sheets.filter((x: any) => x.at_second_progress_rate >= 100 && x.second_approval_flg != x.second_approval_flg_cache).forEach((x: any) => paramSheets.push({id: x.id, approval_flg: x.second_approval_flg}));
      }else{
        state.sheets.filter((x: any) => x.saiten_flg && x.approval_flg != x.approval_flg_cache).forEach((x: any) => paramSheets.push({id: x.id, approval_flg: x.approval_flg}));
      }

      if(paramSheets.length == 0){
        alert("承認状態は変更されていません。");
        return;
      }

      if([CompareNoEnum.CompareFirst, CompareNoEnum.CompareSecond].includes(state.compare_no)){
        // 承認リセット対象に絞り込み
        const resetApprovalSheets = paramSheets.filter((x: any) => !x.approval_flg)

        if(resetApprovalSheets.length > 0){
          // A or B採点の承認解除に連動して最終採点がクリアされるか確認
          await http.post(`/api/teacher/practice_compare_sheet_list/is_compare_final_scored`, {sheets: resetApprovalSheets, compare_no: state.compare_no}).then(response => {
            if(response.data.result){
              // 最終採点がリセットされる試験が含まれている場合はモーダルで注意メッセージを表示
              customConfirmModalRef.value.show();
            }else{
              if(window.confirm("承認状態を更新します。よろしいですか？")){
                updateApproval();
              }
            }
          })
          .catch(error=>{
            if(error.response.status == 422){
              state.errors = error.response.data.errors;
            }else{
              state.errors = ["予期せぬ例外が発生しました。"];
            }
          });
        }else{
          if(window.confirm("承認状態を更新します。よろしいですか？")){
            updateApproval();
          }
        }
      }else{
        if(window.confirm("承認状態を更新します。よろしいですか？")){
          updateApproval();
        }
      }
    }

    /******************************
     * 承認更新
     ******************************/

    const updateApproval = async () => {

      customConfirmModalRef.value.hide();

      const paramSheets: any[] = [];
      if(state.compare_no == CompareNoEnum.CompareFirst){
        state.sheets.filter((x: any) => x.at_first_progress_rate >= 100 && x.first_approval_flg != x.first_approval_flg_cache).forEach((x: any) => paramSheets.push({id: x.id, approval_flg: x.first_approval_flg}));
      }else if(state.compare_no == CompareNoEnum.CompareSecond){
        state.sheets.filter((x: any) => x.at_second_progress_rate >= 100 && x.second_approval_flg != x.second_approval_flg_cache).forEach((x: any) => paramSheets.push({id: x.id, approval_flg: x.second_approval_flg}));
      }else{
        state.sheets.filter((x: any) => x.saiten_flg && x.approval_flg != x.approval_flg_cache).forEach((x: any) => paramSheets.push({id: x.id, approval_flg: x.approval_flg}));
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_compare_sheet_list/update_approval_flg`, {sheets: paramSheets, compare_no: state.compare_no}).then(response => {
        alert("処理が完了しました。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    return {
      ...toRefs(state),
      CompareNoEnum,
      customConfirmModalRef,
      search,
      searchClick,
      clearCondition,
      rowSpan,
      tdStyle,
      trStyle,
      convertExecDate,
      changePage,
      saitenSettingClick,
      reload,
      calcAllAverage,
      approvalButtonClick,
      updateApproval,
      saitenListClick,
    }
  }
});

